export class AIAdapter {
    static API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

    static async sendMessage(message, userContext, conversationHistory = []) {
        try {
            // Get current global and country scores
            const scores = await fetch(`${this.API_BASE}/scores`).then(res => res.json());
            
            // Clean up the message by removing @judex mentions for cleaner AI interaction
            const cleanMessage = message.replace(/@judex/gi, '').trim();
            
            // Create the request body
            const requestBody = { 
                message: cleanMessage,
                conversationHistory,
                userContext: {
                    ...userContext,
                    globalScore: scores.globalScore,
                    countryScores: scores.countryScores
                }
            };
            
            const response = await fetch(`${this.API_BASE}/chat`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error sending message:', error);
            throw error;
        }
    }

    static async searchChatHistory(query, limit = 5) {
        try {
            const response = await fetch(
                `${this.API_BASE}/chat/search?query=${encodeURIComponent(query)}&limit=${limit}`
            );
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            return await response.json();
        } catch (error) {
            console.error('Error searching chat history:', error);
            throw error;
        }
    }

    static async storeInteractionPattern(action, globalScore, countryScores) {
        try {
            const response = await fetch(`${this.API_BASE}/interactions/pattern`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    action,
                    globalScore,
                    countryScores: JSON.stringify(countryScores)
                })
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            return await response.json();
        } catch (error) {
            console.error('Error storing interaction pattern:', error);
            throw error;
        }
    }

    static async getSimilarInteractions(action, globalScore, limit = 5) {
        try {
            const response = await fetch(
                `${this.API_BASE}/interactions/similar?action=${action}&globalScore=${globalScore}&limit=${limit}`
            );
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            return await response.json();
        } catch (error) {
            console.error('Error getting similar interactions:', error);
            throw error;
        }
    }
} 